export const GET_SKU_ATTRIBUTES = 'GET_SKU_ATTRIBUTES';
export const GET_SKU_ATTRIBUTES_SUCCESS = 'GET_SKU_ATTRIBUTES_SUCCESS';
export const GET_SKU_ATTRIBUTES_FAIL = 'GET_SKU_ATTRIBUTES_FAIL';

export const GET_ALL_ATTRIBUTES = 'GET_ALL_ATTRIBUTES';
export const GET_ALL_ATTRIBUTES_SUCCESS = 'GET_ALL_ATTRIBUTES_SUCCESS';
export const GET_ALL_ATTRIBUTES_FAIL = 'GET_ALL_ATTRIBUTES_FAIL';

export const GET_INHERIT_TYPES = 'GET_INHERIT_TYPES';
export const GET_INHERIT_TYPES_SUCCESS = 'GET_INHERIT_TYPES_SUCCESS';
export const GET_INHERIT_TYPES_FAIL = 'GET_INHERIT_TYPES_FAIL';

export const SAVE_SKU_ATTRIBUTES = 'SAVE_SKU_ATTRIBUTES';
export const SAVE_SKU_ATTRIBUTES_SUCCESS = 'SAVE_SKU_ATTRIBUTES_SUCCESS';
export const SAVE_SKU_ATTRIBUTES_FAIL = 'SAVE_SKU_ATTRIBUTES_FAIL';

export const GET_AVAILABLE_OPERATIONS = 'GET_AVAILABLE_OPERATIONS';
export const GET_AVAILABLE_OPERATIONS_SUCCESS = 'GET_AVAILABLE_OPERATIONS_SUCCESS';
export const GET_AVAILABLE_OPERATIONS_FAIL = 'GET_AVAILABLE_OPERATIONS_FAIL';

export const GET_ALL_OPERATIONS = 'GET_ALL_OPERATIONS';
export const GET_ALL_OPERATIONS_SUCCESS = 'GET_ALL_OPERATIONS_SUCCESS';
export const GET_ALL_OPERATIONS_FAIL = 'GET_ALL_OPERATIONS_FAIL';

export const SAVE_AVAILABLE_OPERATIONS = 'SAVE_AVAILABLE_OPERATIONS';
export const SAVE_AVAILABLE_OPERATIONS_SUCCESS = 'SAVE_AVAILABLE_OPERATIONS_SUCCESS';
export const SAVE_AVAILABLE_OPERATIONS_FAIL = 'SAVE_AVAILABLE_OPERATIONS_FAIL';

export const CREATE_OPERATION = 'CREATE_OPERATION';
export const CREATE_OPERATION_SUCCESS = 'CREATE_OPERATION_SUCCESS';
export const CREATE_OPERATION_FAIL = 'CREATE_OPERATION_FAIL';

export const DELETE_ATTR = 'DELETE_ATTR';
export const DELETE_ATTR_SUCCESS = 'DELETE_ATTR_SUCCESS';
export const DELETE_ATTR_FAIL = 'DELETE_ATTR_FAIL';
